<template>
	<div class="base-page clickhint-page">
		<div class="card">
	        <div class="card-body">
	            <div class="d-flex justify-content-between align-items-center">
                    <img src="/assets/img/clickhint.png" width="120"/>
                    <a href="/logout" class="blue-link">LOG OUT</a>
                </div>
	        </div>
	    </div>

        <div class="alert alert-info" v-if="requesting">
            <i class="fa fa-btn fa-spinner fa-spin"></i> Hang on. We are processing your request.
        </div>

        <div class="alert alert-success" v-if="successMessage != ''">
            {{ successMessage }}
        </div>

	    <div class="row">
            <div class="col-md-12">
                <div class="card my-hotels-card">
                    <div class="card-header">
                        <h5 class="header-case">My Hotels</h5>
                    </div>
                    <div class="card-body">
                        <div class="create-new-hotel" v-if="currentTeams != null && currentTeams.length == 0">
                            <div class="row justify-content-center">
                                <div class="col-md-12">
                                    <p class="text-center"><img src="/assets/img/gf_lamp.png"/></p>
                                    <p class="thin-title text-center mb-5">It's time to create your hotel.</p>
                                    <div class="row justify-content-center">
                                        <div class="col-md-8">
                                            <h4 class="header-case">Property Name</h4>
                                            <div class="d-flex justify-content-center">
                                                <input v-model="newHotelName" type="text" class="form-control" placeholder="Enter Property Name" />
                                                <button :disabled="creating" @click="createHotel" class="btn btn-primary">Create</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="my-hotels" v-else>
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>Property</th>
                                        <th>Plan</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tr v-for="team in currentTeams">
                                    <th scope="row">{{ team.name }}</th>
                                    <td>
                                        <strong v-if="team.expires == 'Expired'">Expired</strong>
                                        <span v-else>{{ team.plan_name }} until {{ team.expires }}</span>
                                    </td>
                                    <td>

                                        <div class="dropdown show">
                                            <a href="#" class="d-block d-md-flex text-center settings-link dropdown-toggle align-items-center" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                <i class="fa fa-cog brand-primary-gradient mr-2"></i>
                                                <span>Manage</span>
                                            </a>
                                            
                                            <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                                <a href="#" @click.prevent="inviteMembers(team)" v-if="team.role == 'owner'" class="dropdown-item">
                                                    <i class="fas fa-envelope mr-2"></i> Invite Users
                                                </a>
                                                <a href="#" @click.prevent="editPlaceholders(team.id)" class="dropdown-item">
                                                    <i class="fas fa-comment mr-2"></i> Edit Placeholders
                                                </a>
                                                <a href="#" @click.prevent="editTemplates(team.id)" class="dropdown-item">
                                                    <i class="fas fa-comment mr-2"></i> Edit Templates
                                                </a>
                                                <a href="#" @click.prevent="editConnections(team)" class="dropdown-item">
                                                    <i class="fas fa-share-alt mr-2"></i> Manage Connections
                                                </a>
                                                <a class="dropdown-item" href="#" @click.prevent="requestUpgrade(team.id)" v-if="team.expires === 'Exired' || team.plan === 'free'">
                                                    <i class="fas fa-star mr-2"></i> Request Upgrade
                                                </a>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
	    </div>

	    <div id="ch-extension-dl" ref="download_prompt" style="display: none">
    		<div class="card">
    			<div class="card-body">
    				<div class="row align-items-center">
    					<div class="col-md-4">
    						<img src="/assets/img/chrome-webstore.png" class="mw-100" alt="Chrome Webstore"/>
    					</div>
    					<div class="col-md-8">
    						Please <a href="https://chrome.google.com/webstore/detail/clickhint/eeaibjchkamicdalnificoojfpdachbp" class="bp"><b>download</b></a> or enable the extension.
    					</div>
    				</div>
    			</div>
    		</div>
	    </div>

        <div class="go-back text-center" v-if="isGf">
            <a :href="location"><i class="fa fa-arrow-left"></i> Go back to GuestFlip</a>
        </div>

        <div id="upgrade" class="card d-none" :class="{'needs-upgrade': highlightUpgrade}">
            <div class="card-header">
                <h2 class="header-case mb-0">UPGRADE</h2>
            </div>
            <div class="card-body">
                <div v-show="account.plan == 'Pro'">
                    <p class="thin-text">Looking to upgrade to our enterprise plans?</p>
                    <a href="https://clickhint.com/contact" target="_blank" class="bp">Contact Sales</a>
                    <a href="javascript:void(0)" class="btn btn-primary" data-cb-type="portal"><i class="fas fa-wrench"></i> Manage subscription</a>
                </div>
                <div v-show="account.plan == 'Free' || account.expires == 'Expired'">
                    <p>With our Pro package you can deliver high-quality responses to your guests on time, every time.</p>
                    <ul>
                        <li>Works with every source language</li>
                        <li>Support responses in 3 Languages</li>
                        <li>Works with your reputation management tool</li>
                    </ul>
                    <a href="javascript:void(0)" data-cb-type="checkout" data-cb-plan-id="clickhint-premium" class="btn btn-primary">
                        Subscribe
                    </a>
                </div>
            </div>
        </div>

        <div class="modal fade" ref="clickhint_modal" aria-label="Modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog gf modal-dialog-centered" role="document" :class="{'full-width': activeModal !== 'upgrade' && activeModal !== 'invite'}">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true"><i class="fa fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <component :is="activeComponent" :team_id="modalTeamId" :team="modalTeam"></component>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import ClickHintConnections from './ClickHintConnections';
import ClickHintInviteColleagues from './ClickHintInviteColleagues';
export default {
    props: ['teams', 'user'],
    components: {
        ClickHintConnections,
        ClickHintInviteColleagues,
    },
	data() {
		return {
			account: {
				plan: 'Free',
				expires: 'Never'
			},
            allHints: [],
            currentTeams: null,
            newHotelName: '',
            creating: false,
            activeModal: '',
            modalTeamId: null,
            modalTeam: null,
            highlightUpgrade: false,
            startPath: '/',
            successMessage: '',
            requesting: false
		}
	},
    computed: {
        isGf() {
            return window.location.pathname.includes('extension');
        },
        location() {
            return window.location.origin;
        },
        activeComponent() {
            if (this.activeModal == 'placeholders') {
                return 'edit-response-placeholders';
            }
            if (this.activeModal == 'templates') {
                return 'edit-response-templates';
            }
            if (this.activeModal == 'invite') {
                return 'click-hint-invite-colleagues';
            }
            if (this.activeModal == 'connections') {
                return 'click-hint-connections';
            }
        },
        stats() {
            let total = this.allHints.length

            let startOfMonth = moment().startOf('month').format('YYYY-MM-DD H:mm:ss')

            let thisMonth = this.allHints.filter(element => {
                return element.created_at > startOfMonth
            })

            return {
                hintsUsed: total,
                hintsUsedThisMonth: thisMonth.length
            }
        }
    },
	mounted() {
        let instance = this 
        this.startPath = window.location.pathname.includes('extension') ?
            `${window.location.origin + '/extension'}` : `${window.location.origin}`;

		setTimeout(function() {
			instance.$refs.download_prompt.style.display = 'block'
		}, 750)

        var url = new URL(window.location.href);
        var lr = url.searchParams.get("lr");

        if (lr) {
            this.requestUpgrade(lr);
        }

        this.getTeams()
        this.getStats()
	},
    methods: {
        requestUpgrade(team) {
            this.requesting = true;
            this.successMessage = '';
            var append = `/${team}`
            if (team === 'true') {
                append = ''
            }
            axios.get(`${this.startPath}/upgrade-request${append}`)
            .then(response => {
                this.requesting = false;
                this.successMessage = 'We have received your request to upgrade. We will be in contact with you soon.';
            })
        },
        editPlaceholders(teamId) {
            this.modalTeamId = teamId
            $(this.$refs.clickhint_modal).modal('toggle')
            this.activeModal = 'placeholders'
        },
        editTemplates(teamId) {
            this.modalTeamId = teamId
            $(this.$refs.clickhint_modal).modal('toggle')
            this.activeModal = 'templates'
        },
        inviteMembers(team) {
            this.modalTeam = team
            $(this.$refs.clickhint_modal).modal('toggle')
            this.activeModal = 'invite'
        },
        editConnections(team) {
            this.modalTeam = team
            $(this.$refs.clickhint_modal).modal('toggle')
            this.activeModal = 'connections'
        },
        viewHintLogs() {

        },
        createHotel() {
            if (this.newHotelName.length < 3) {
                swal("Whoops!", 'The property name you entered is too short.', "error")
            }

            let payload = {
                name: this.newHotelName
            }

            this.creating = true;
            axios.post(`${this.startPath}/new-team`, payload)
            .then(response => {
                this.creating = false;
                swal('Awesome!', 'You just added a hotel!', "success")
                // Reload teams
                this.getTeams()
            })
        },
        getTeams() {
            axios.get(`${this.startPath}/user-teams`)
            .then(response => {
                this.currentTeams = response.data.teams
            })
        },
        getStats() {
            if (! Spark.state.currentTeam) {
                return
            }
            axios.get(`${this.startPath}/stats`)
            .then(response => {
                this.allHints = response.data.stats
                this.account = response.data.account
            })
        }
    }
}
</script>

<style>
.do-not-show {
	display: none !important;
}
.needs-upgrade {
    border: solid 2px #20b4a8;
    transition: border 0.5s;
}
</style>